

import * as enums from './doc/enums'
import Workbook from './doc/workbook';

export default {
  Workbook,
  enums
}
